import { api } from '.';

import { ApiRoutes } from '@/constant/api';

import {
	PassTypeRequestBodyType,
	PassTypeUpdateRequestType,
	PassTypesResponseType,
} from '@/types/pass-types';

const passTypesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		//=====PASS_TYPES======//
		getPassTypes: builder.query<PassTypesResponseType, string>({
			query: () => ({
				url: ApiRoutes.PassTypes,
			}),
			providesTags: ['PassTypes'],
		}),
		createPassType: builder.mutation<null, PassTypeRequestBodyType>({
			query: (body) => ({
				url: ApiRoutes.PassTypes,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['PassTypes'],
		}),
		updatePassType: builder.mutation<null, PassTypeUpdateRequestType>({
			query: ({ id, body }) => ({
				url: `${ApiRoutes.PassTypes}/${id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['PassTypes'],
		}),
		deletePassType: builder.mutation<null, number>({
			query: (id) => ({
				url: `${ApiRoutes.PassTypes}/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['PassTypes'],
		}),
	}),
});

export const {
	useGetPassTypesQuery,
	useCreatePassTypeMutation,
	useDeletePassTypeMutation,
	useUpdatePassTypeMutation,
} = passTypesApi;
